export default class MultipleStringsUI {
  public constructor(private $base: JQuery) {}

  public getContent(): string[] {
    return this.$base.find('input').val().toString().split(',');
  }

  public getName() {
    return this.$base.find('input').attr('name');
  }

  public addButton() {
    const button = document.createElement('button');
    button.classList.add('button');
    button.classList.add('button--tiny');
    button.classList.add('button--flat');
    button.style.marginTop = '-5px';
    button.style.marginBottom = '15px';
    button.addEventListener('click', (e) => {
      e.preventDefault();
      this.addSingleInput(this.getName());
    });
    button.innerHTML = 'Add more';
    this.$base.append(button);
  }

  public addSingleInput(name: string) {
    const input = document.createElement('input');
    input.type = 'text';
    input.name = name + '[]';
    input.setAttribute('name', name);
    this.$base.find('label').append(input);
  }

  public render(values: string[], name: string) {
    this.$base.find('.js-configinput').remove();

    if (values.length === 0) {
      const div = document.createElement('div');
      div.classList.add('multiple-input-wrapper');
      const button = document.createElement('button');
      button.classList.add('button');
      button.classList.add('button--tiny');
      button.classList.add('button--danger');
      button.innerHTML = 'Remove';
      button.addEventListener('click', (e) => {
        e.preventDefault();
        $(e.currentTarget).parent().remove();
      });

      const input = document.createElement('input');
      input.type = 'text';
      input.name = name + '[]';
      input.setAttribute('name', name + '[]')
      div.appendChild(input);
      div.appendChild(button);
      this.$base.find('label').append(div);
    }
    else {
      values.map((value) => {
        const div = document.createElement('div');
        div.classList.add('multiple-input-wrapper');
        const input = document.createElement('input');

        const button = document.createElement('button');
        button.innerHTML = 'Remove';
        button.classList.add('button');
        button.classList.add('button--tiny');
        button.classList.add('button--danger');
        button.addEventListener('click', (e) => {
          e.preventDefault();
          $(e.currentTarget).parent().remove();
        });

        input.type = 'text';
        input.name = name + '[]';
        input.value = value
        input.setAttribute('value', value)
        input.setAttribute('name', name + '[]')

        div.appendChild(input);
        div.appendChild(button);
        this.$base.find('label').append(div);
      });
    }
  }
}
